import React, { Component } from "react";
import { Modal } from "react-bootstrap";

class RemoveCertificate extends Component {
    render() {
        const { open, close, index, remove } = this.props;
        return (
            <Modal
                centered
                show={open}
                onHide={close}
                className="remove-certificate-modal"
            >
                <Modal.Header className="header">
                    <button onClick={close} data-dismiss="modal" aria-label="Close" className="close">
                        <i className="mdi mdi-close"></i>
                    </button>
                    <br />
                    <Modal.Title className="title">Remove</Modal.Title>
                </Modal.Header>
                <Modal.Body className="body">
                    <p className="sub-title">Are you sure you want to remove this certificate?</p>
                </Modal.Body>
                <Modal.Footer className="footer">
                    <button className="back" onClick={close}>
                        <i className="fa fa-angle-left"></i>Back
                    </button>
                    <button className="remove" onClick={ () => remove(index) }>
                        Remove
                    </button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default RemoveCertificate;